import React from 'react';

export const IMAGE_FIELD_NAMES = ['image', 'imageUrl', 'photo', 'thumbnail', 'thumbnailUrl', 'picture', 'coverImage', 'coverImageUrl'];

export function parseHotelData(content) {
  try {
    if (typeof content === 'string') {
      const parsed = JSON.parse(content);
      if (parsed.hotels || parsed.hotelOptions || parsed.results) {
        return parsed.hotels || parsed.hotelOptions || parsed.results;
      }
      return null;
    }
    if (content.hotels || content.hotelOptions || content.results) {
      return content.hotels || content.hotelOptions || content.results;
    }
    return null;
  } catch (e) {
    return null;
  }
}

export function parseStructuredMessage(response) {
  if (!response) return null;

  if (Array.isArray(response.conversationHistory)) {
    const lastAssistant = [...response.conversationHistory].reverse().find(
      m => m.role === 'assistant'
    );
    if (lastAssistant?.structuredContent) {
      return lastAssistant.structuredContent;
    }
  }

  return null;
}

export function getFirstStringField(source, fieldNames) {
  if (!source) return null;
  for (const fieldName of fieldNames) {
    const value = source[fieldName];
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }
  return null;
}

export function getActivityImageUrl(item) {
  return getFirstStringField(item, IMAGE_FIELD_NAMES) || null;
}

const URL_REGEX = /(https?:\/\/[^\s<]+[^\s<.,;:!?)"'\]])/gi;

function renderStrikethrough(text) {
  const parts = text.split(/(~~.+?~~)/g);
  if (parts.length === 1) return text;
  return parts.map((part, i) => {
    if (part.startsWith('~~') && part.endsWith('~~')) {
      return <s key={i}>{part.slice(2, -2)}</s>;
    }
    return part;
  });
}

export function linkifyText(text) {
  if (!text) return text;
  const urlParts = text.split(URL_REGEX);
  if (urlParts.length === 1) return renderStrikethrough(text);
  return urlParts.map((part, i) => {
    if (part.startsWith('http://') || part.startsWith('https://')) {
      return <a key={i} href={part} target="_blank" rel="noopener noreferrer">{part}</a>;
    }
    return renderStrikethrough(part);
  });
}
